import React,{useState} from 'react'
import './RegisterForm.scss'
import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
import {faLock,faUser} from '@fortawesome/free-solid-svg-icons'
import {faGoogle, faSteam} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '../button/Button'

const RegisterForm = ({onClose,onLogin}) => {

    const [change,setChange] = useState({name:'',email:'', password:'',passwordconfirm:''})

    return (
        <>
            <div className="register">
                <div className="register__container">
                    
                    <div className="register-closetag">
                        <p onClick={onClose}>X</p>
                    </div>

                    <div className="register__container-wrap">
                        <div className="register-header">
                            <h1>Create Account</h1>
                        </div>

                        <div className="register-form-name">
                            <FontAwesomeIcon icon={faUser} size='lg' className="close"/>
                            <input 
                                type="text"
                                className="register-form-name-wrap"
                                placeholder="Name"
                                value={change.name}
                                onChange={(e) => setChange({...change,name:e.target.value})}
                            />
                        </div>
                        <div className="register-form-email">
                            <FontAwesomeIcon icon={faEnvelope} size='lg' className="close"/>
                            <input 
                                type="text" 
                                className="register-form-email-wrap" 
                                placeholder="Email"
                                value={change.email}
                                onChange={(e) => setChange({...change,email:e.target.value})}
                            />
                        </div>
                        <div className="register-form-password">
                            <FontAwesomeIcon icon={faLock} size='lg' className="close"/>
                            <input 
                                type="password"
                                className="register-form-password-wrap"
                                placeholder="Password"
                                value={change.password}
                                onChange={(e) => setChange({...change,password:e.target.value})}
                            />
                        </div>
                        <div className="register-form-passwordconfirm">
                            <FontAwesomeIcon icon={faLock} size='lg' className="close"/>
                            <input 
                                type="password"
                                className="register-form-passwordconfirm-wrap"
                                placeholder="Password Confirm"
                                value={change.passwordconfirm}
                                onChange={(e) => setChange({...change,passwordconfirm:e.target.value})}
                            />
                        </div>
                        <div className="register-check">
                            <input type="checkbox" id="rememberme" value="regcheck" name="regcheck"/>
                            <label htmlFor="regcheck">I agree to the Terms of Services and Privacy Policy</label>
                        </div>
                        <div className="register-button">
                            <Button buttonSize="btn--large" buttonColor="green">REGISTER</Button>
                        </div>
                        <div className="login-choose">
                            <div className="login-choose-web">
                                <div className="login-choose-google">
                                    <FontAwesomeIcon icon={faGoogle} size='lg' className="close"/>
                                    <span></span>
                                    <p>Google</p>
                                </div>
                                <div className="login-choose-steam">
                                    <FontAwesomeIcon icon={faSteam} size='lg' className="close"/>
                                    <span></span>
                                    <p>Steam</p>
                                </div>
                            </div>
                        </div>
                        <div className="register-login">
                            <p>Allready Registerd ? <span onClick={onLogin}>Login</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RegisterForm
